<script setup>
import { inject } from "vue";
import InputField from "@/Components/InputField.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";

import { useForm } from "@inertiajs/vue3";
const route = inject('route');

const form = useForm({
  current_password: "",
  password: "",
  password_confirmation: "",
});

const submit = () => {
  form.put(route("profile.password"), {
    onSuccess: () => form.reset(),
    onError: () => form.reset(),
    preserveScroll: true,
  });
};
</script>

<template>
  <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
    <div class="mb-6">
      <h2 class="text-xl font-semibold text-slate-900">Ubah Kata Sandi</h2>
      <p class="mt-1 text-sm text-slate-600">
        Pastikan menggunakan kata sandi yang panjang dan acak untuk keamanan
        akun Anda.
      </p>
    </div>

    <ErrorMessages :errors="form.errors" />

    <form @submit.prevent="submit" class="space-y-6">
      <div class="space-y-6">
        <InputField
          label="Kata Sandi Saat Ini"
          icon="key"
          type="password"
          v-model="form.current_password"
          required
          autocomplete="current-password"
        />

        <InputField
          label="Kata Sandi Baru"
          icon="key"
          type="password"
          v-model="form.password"
          required
          autocomplete="new-password"
        />

        <InputField
          label="Konfirmasi Kata Sandi Baru"
          icon="key"
          type="password"
          v-model="form.password_confirmation"
          required
          autocomplete="new-password"
        />
      </div>

      <div
        v-if="form.recentlySuccessful"
        class="rounded-md bg-green-50 p-4 border border-green-200"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-green-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.236 4.53L7.53 10.53a.75.75 0 00-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-green-800">
              Kata sandi berhasil diubah!
            </p>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end pt-4 border-t border-slate-200">
        <PrimaryBtn
          :disabled="form.processing"
          class="bg-maroon-600 hover:bg-maroon-700 focus:ring-maroon-500"
        >
          <span v-if="form.processing">Menyimpan...</span>
          <span v-else>Ubah Kata Sandi</span>
        </PrimaryBtn>
      </div>
    </form>
  </div>
</template>
